import { render, staticRenderFns } from "./page-container.component.vue?vue&type=template&id=a7727924&"
import script from "./page-container.component.vue?vue&type=script&lang=ts&"
export * from "./page-container.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports